import { render, staticRenderFns } from "./ExhibitorCard.vue?vue&type=template&id=0d37b796&scoped=true&"
import script from "./ExhibitorCard.vue?vue&type=script&lang=js&"
export * from "./ExhibitorCard.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitorCard.vue?vue&type=style&index=0&id=0d37b796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d37b796",
  null
  
)

export default component.exports